module.exports = __webpack_public_path__ + "static/media/note-taker.8293ecdc.png";